import { render, staticRenderFns } from "./EducationVideoModalTrigger.vue?vue&type=template&id=2de1fd7c&"
import script from "./EducationVideoModalTrigger.vue?vue&type=script&lang=js&"
export * from "./EducationVideoModalTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports